export const getFileType = (
  sourceUrl?: string,
): "ppt" | "xls" | "csv" | "doc" | "pdf" | "unknown" => {
  if (!sourceUrl) return "unknown";

  // Remove query parameters and fragments (e.g., "file.pptx?web=1" -> "file.pptx")
  const cleanUrl = sourceUrl.split(/[?&#]/)[0];

  // Extract the extension
  const extension = cleanUrl.split(".").pop()?.toLowerCase();

  switch (extension) {
    case "ppt":
    case "pptx":
      return "ppt";
    case "xls":
    case "xlsx":
      return "xls";
    case "csv":
      return "csv";
    case "doc":
    case "docx":
      return "doc";
    case "pdf":
      return "pdf";
    default:
      return "unknown";
  }
};
